import { useDispatch } from 'react-redux';
import {
  IOktaAccessToken,
  IOktaIdToken,
  getIsCypressOnLocalhost,
} from 'sure-platform-sdk';

import { createRenttrackUser } from '../store/actions';

export default function useRenttrack(
  oktaIdToken: IOktaIdToken | null | undefined,
  oktaAccessToken: IOktaAccessToken | null | undefined
) {
  const { accessToken } = oktaAccessToken ?? {};
  const dispatch = useDispatch();

  function createNewRenttrackUser() {
    return dispatch(createRenttrackUser());
  }

  const creditBuilder = oktaIdToken?.claims?.CreditBuilder;
  const hasLevelCreditAccount = !!creditBuilder && creditBuilder !== 'none';

  const baseUrl = getIsCypressOnLocalhost()
    ? 'https://www.example.com'
    : process.env.REACT_APP_LEVELCREDIT_BASE_URL;
  const levelCreditRedirectUrl = `${baseUrl}/?toggle=${accessToken}`;

  return {
    hasLevelCreditAccount,
    levelCreditRedirectUrl,
    createNewRenttrackUser,
  };
}
